import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { AttachedFileDto, AttachedFileType } from 'models';
import Select from 'react-select';
import { CenteredSpinner } from 'components/Common/CenteredSpinner';

export interface IChooseFolderForm {
    fileId: string;
}
interface IChooseFolderFormProps {
    directories: AttachedFileDto[];
    parents: AttachedFileDto[];
    title: string;
    editedItem: IChooseFolderForm;
    cancel: () => void;
    //ok: () => void;
    submit: (data: IChooseFolderForm) => void;
    selectedFolder: AttachedFileDto;
}
const validationSchema = z.object({
    fileId: z.string(),
});


interface AttachedFileDtoWithLevel {
    file: AttachedFileDto;
    level: number;
}

function createDirectoryTree(root: AttachedFileDto, rest: AttachedFileDto[]): AttachedFileDtoWithLevel[] {
    let result: AttachedFileDtoWithLevel[] = [];
    let levelItems: AttachedFileDtoWithLevel[] = [];

    levelItems.push({
        file: {...root},
        level: 0
    }); // Start node

    while (true) {
        const current = levelItems.shift();
        if (current) {
            const tmp = rest.filter(x => x.parentId == current.file.id);
            rest = rest.filter(x => x.parentId != current.file.id);

            const tmp2 = tmp.map(x => {
                const fileName = " ".repeat(current.level + 1) + x.fileName;
                return ({
                    file: { ...x, ...{fileName: fileName} },
                    level: current.level + 1,
                });
            });

            levelItems = [...levelItems, ...tmp2];
            result.push(current);
        } else {
            break;
        }
    }
    // TODO: add any remaining in rest here, unprocessed.
    return result;
}

export function ChooseFolderForm(props: IChooseFolderFormProps) {
    const cancel = () => props.cancel();

    const {
        register, handleSubmit, reset, formState: { errors }, control, watch
    } = useForm<IChooseFolderForm>({
        resolver: zodResolver(validationSchema),
        //defaultValues: props.editedItem,
        values: {fileId: props.selectedFolder?.id},
        resetOptions: {
            keepDirtyValues: true,
            keepErrors: true, // input errors will be retained with value update
        }
    });

    const allFields = watch();
    console.log("ChooseFolderForm: selectedOptions", allFields);
    // console.log("errors", errors);
    // console.log("props.editedItem", props.editedItem);

    const [allDirectories, setAllDirectories] = useState<AttachedFileDtoWithLevel[]>([]);

    useEffect(() => {
        let items: AttachedFileDtoWithLevel[] = [];
        let root = props.parents?.length > 0 ? props.parents[0] : (props.selectedFolder.type === AttachedFileType.Root ? props.selectedFolder : null)
        if (props.parents?.length > 0 && props.directories) {
            root = props.parents[0];
        }
        if (root && props.directories) {
            items = createDirectoryTree(root, props.directories);
        }
        console.log("Choose folder Form items=", items, props.parents, props.directories);
        setAllDirectories(items);
    }, [props.directories, props.parents, props.selectedFolder]);

    const everythingLoaded = !!allDirectories;

    return (
        <>
            <Modal show={true} onHide={cancel} size='lg'>
                {everythingLoaded && (
                <Form onSubmit={handleSubmit(props.submit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className={`mb-3 ${errors.fileId ? 'is-invalid' : ''}`} controlId="formFileId">
                            <Form.Label>Destinationsmapp</Form.Label>

                            <Controller
                                control={control}
                                name="fileId"
                                render={({
                                    field: { onChange, onBlur, value: formFieldValue, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,
                                }) => {
                                    //console.log("error", error);
                                    return (
                                        <Select
                                            value={allDirectories?.find((u) => u.file.id == formFieldValue)}
                                            onChange={(newValue) => onChange(newValue.file.id)}
                                            options={allDirectories}
                                            //getOptionLabel={val => `${val.file.fileName}`}
                                            formatOptionLabel={(data, x) => {return <div style={{display: "flex", justifyContent: "left"}}><div style={{marginLeft: (data.level * 10) + "px"}}></div> <div>{data.file.type === AttachedFileType.Root ? "Hem" : data.file.fileName}</div></div>}}
                                            getOptionValue={val => val.file.id}
                                            className='react-select'
                                            autoFocus={true}
                                        />
                                    );
                                }} />

                            {errors.fileId && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={cancel}>
                            Avbryt
                        </Button>
                        <Button variant="primary" type="submit">
                            Välj
                        </Button>
                    </Modal.Footer>
                </Form>)}
                {!everythingLoaded && (<CenteredSpinner />)}
            </Modal>
        </>

    );
}
